import { createSlice, current } from "@reduxjs/toolkit";
import { ICreateProjectReduxState } from "./CreateProjectInteface";
import { ProjectModeEnum } from "../../core/enumerations/ProjectModeEnum";

const initialState: ICreateProjectReduxState = {
  isLoading: false,
  error: "",
  success: "",
  textCardBackgroundColor: "rgba(255, 255, 255)",
  previousBackgroundColor: "rgba(13, 13, 13, 1)",
  myProjects: {},
  myCollaboratedProjects: {},
  artistData: {
    invitedArtists: [],
  },
  basicInfoErrors: {
    projectName: "",
    category: "",
    ownershipType: "",
    revenueShareType: "",
    startDate: "",
    endDate: "",
    googleAddress: "",
    country: "",
  },
  isProjectCreated: false,
  isProjectMediaAdded: false,
  projectId: "",
  usersListBasedOnSkill: {},
  // sharePercentageError: [],
  customUploadedImage: null,
  projectDetailsToBeEdited: {},
  projectDetails: {
    coverImage: {},
    basicProjectInfo: {
      name: "",
      categoryId: "",
      copyRightType: "",
      revenueSplitType: "",
      startDate: null,
      endDate: null,
      description: "",
      projectMode: ProjectModeEnum.online,
      address: "",
      latitude: "",
      longitude: "",
      country: "",
      state: "",
      city: "",
    },
    mediaContent: [],
    collaboratorRequirements: [],
    projectOwnerSkills: [],
    deletedMedias: []
  },
  isShowMap: false,
  manualAddress: { address: "", isAddressFetchedFromMap: false },
  isAddressFetchedFromMap: false,
  savedProjects: {},
  createProjectChatGroup: false,
  groupRequestData: {},
};

export const createProjectRedux: any = createSlice({
  name: "createProjectRedux",
  initialState,
  reducers: {
    setCreateProjectState: (state: any, action: any) => {
      const newState = {
        ...state,
      };
      newState[action.payload.key] = action.payload.value;
      return newState;
    },

    resetCreateProjectState: (state: any) => {
      const newState = {
        ...state,
      };
      const data = {
        coverImage: "",
        basicProjectInfo: {
          name: "",
          categoryId: "",
          copyRightType: "",
          revenueSplitType: "",
          startDate: null,
          endDate: null,
          description: "",
          projectMode: ProjectModeEnum.online,
          address: "",
          country: "",
          state: "",
          city: "",
        },
        mediaContent: [],
        collaboratorRequirements: [],
        projectOwnerSkills: [],
        deletedMedias: []
      };
      newState["projectDetails"] = data;
      return newState;
    },

    getUsersListBasedOnSkillIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        usersListBasedOnSkill: {},
      };
      return newState;
    },

    getUsersListBasedOnSkillIdSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        usersListBasedOnSkill: action.payload.data,
        isLoading: false,
      };
      return newState;
    },

    getUsersListBasedOnSkillIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    createProjectRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        groupRequestData: {},
        createProjectChatGroup: false,
      };
      return newState;
    },

    createProjectSuccess: (state: any, action: any) => {
      const response = action.payload.data;
      const newState = {
        ...state,
        isProjectCreated: true,
        projectId: response?.data?.projectId,
        isLoading: false,
        createProjectChatGroup: true,
        groupRequestData: {
          projectId: response?.data?.projectId,
          projectName: response?.basicProjectInfo?.name,
          projectOwnerId: response?.data?.createdBy,
        }
      };
      return newState;
    },

    createProjectFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isProjectCreated: false,
        isLoading: false,
        groupRequestData: {},
        createProjectChatGroup: false,
      };
      return newState;
    },

    uploadProjectMediaRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    uploadProjectMediaSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isProjectMediaAdded: true,
        isLoading: false,
      };
      return newState;
    },

    uploadProjectMediaFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    getAllMyProjectsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPaginationLoading: true,
      };
      return newState;
    },

    getAllMyProjectsSuccess: (state: any, action: any) => {
      // const newState = {
      //   ...state,
      //   myProjects: action.payload.data,
      //   isLoading: false,
      // };
      // return newState;

      const previousData = current(state?.myProjects);

      const previousProjects = previousData?.responseData?.projectDetails
        ? previousData?.responseData?.projectDetails
        : [];

      let response = {
        ...action.payload.data
      }

      const formatedData = response?.currentPage === 1 ? [] : previousProjects;

      const newState = {
        ...state,
        myProjects: {
          ...response,
          responseData: {
            ...response.responseData,
            projectDetails: [...formatedData, ...response?.responseData?.projectDetails]
          },
        },
        isLoading: false,
        isPaginationLoading: false,
      };

      return newState;
    },

    getAllMyProjectsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;
    },

    getAllMyCollaboratedProjectsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPaginationLoading: true,
      };
      return newState;
    },

    getAllMyCollaboratedProjectsSuccess: (state: any, action: any) => {
      // const newState = {
      //   ...state,
      //   myCollaboratedProjects: action.payload.data,
      //   // isLoading: false,
      // };
      // return newState;

      const previousData = current(state?.myCollaboratedProjects);

      const previousProjects = previousData?.responseData?.projectDetails
        ? previousData?.responseData?.projectDetails
        : [];

      let response = {
        ...action.payload.data
      }

      const formatedData = response?.currentPage === 1 ? [] : previousProjects;

      const newState = {
        ...state,
        myCollaboratedProjects: {
          ...response,
          responseData: {
            ...response.responseData,
            projectDetails: [...formatedData, ...response?.responseData?.projectDetails]
          },
        },
        isLoading: false,
        isPaginationLoading: false,
      };

      return newState;
    },

    getAllMyCollaboratedProjectsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;
    },
    updateProjectRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProjectCreated: false,
      };
      return newState;
    },

    updateProjectSuccess: (state: any, action: any) => {

      const newState = {
        ...state,
        isProjectCreated: true,
        isLoading: false,
      };
      return newState;
    },

    updateProjectFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isProjectCreated: false,
        isLoading: false,
      };
      return newState;
    },

    saveProjectRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    saveProjectSuccess: (state: any, action: any) => {

      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    saveProjectFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    getAllSavedProjectsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getAllSavedProjectsSuccess: (state: any, action: any) => {

      const previousSavedProjects = current(state?.savedProjects);
      const response = action.payload?.data;
      const previousResponseData = response?.currentPage === 1 ? [] : previousSavedProjects?.responseData;
      const newState = {
        ...state,
        isLoading: false,
        savedProjects: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...previousResponseData, ...response.responseData],
        },
      };
      return newState;
    },

    getAllSavedProjectsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
  },
});

export const {
  setCreateProjectState,
  resetCreateProjectState,

  getUsersListBasedOnSkillIdRequest,
  getUsersListBasedOnSkillIdSuccess,
  getUsersListBasedOnSkillIdFailure,

  createProjectRequest,
  createProjectSuccess,
  createProjectFailure,

  uploadProjectMediaRequest,
  uploadProjectMediaSuccess,
  uploadProjectMediaFailure,

  updateProjectRequest,
  updateProjectSuccess,
  updateProjectFailure,

  getAllSavedProjectsRequest,
  getAllSavedProjectsSuccess,
  getAllSavedProjectsFailure,
} = createProjectRedux.actions;

export default createProjectRedux.reducer;
